import Http, {RequestParams} from "@hview/hview-http";

/**
 * @description 获取用户信息
 * @param params
 */
export const getMemberDataApi = (params: RequestParams) => Http.post("/api/v2/doctor/member/getMemberData", params);

/**
 * @description 获取表单列表
 * @param params
 */
export const getFormListApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getFormList", params);

/**
 * @description 创建表单
 * @param params
 */
export const submitFormApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/submitForm", params);

/**
 * @description 修改表单
 * @param params
 */
export const updateFormApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/updateForm", params);


/**
 * @description 获取表单信息
 * @param params
 */
export const getFormInfoApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getFormInfo", params);

/**
 * @description 通过resultId获取填写结果
 * @param params
 */
export const getFormResultApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getFormResult", params);

/**
 * @description 通过fromid查询当前表单下填写的数据
 * @param params
 */
export const getFromUserResultListApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getFromUserResultList", params);
export const getFromUserResultListApis = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getFromUserResultLists", params);
/**
 * @description 提交用户表单
 * @param params
 */
export const submitUserResultApi = (params: RequestParams, formId: number) => {
    return Http.post(`/api/v2/doctor/Customform/submitUserResult?id=${formId}`, params);
}

/**
 * @description 删除表单
 * @param params
 */
export const deleteFormApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/deleteForm", params);

/**
 * @description 获取文章列表
 * @param params
 */
export const getArticleListApi = (params: RequestParams) => Http.post("/api/v2/doctor/article/getArticleList", params);

/**
 * @description 创建文章
 * @param params
 */
export const addArticleApi = (params: RequestParams) => Http.post("/api/v2/doctor/article/addArticle", params);

/**
 * @description 获取文章
 * @param params
 */
export const getArticleInfoApi = (params: RequestParams) => Http.post("/api/v2/doctor/article/getArticleInfo", params);
/**
 * @description 获取关联商品
 * @param params
 */
export const getGoodsListApi = (params: RequestParams) => Http.post("/api/v2/mall/getGoodsList", params);

/**
 * @description 修改文章
 * @param params
 */
export const updateArticleApi = (params: RequestParams) => Http.post("/api/v2/doctor/article/updateArticle", params);

/**
 * @description 删除文章
 * @param params
 */
export const deleteArticleApi = (params: RequestParams) => Http.post("/api/v2/doctor/article/deleteArticle", params);

/**
 * @description 将用户移除社区
 * @param params teamId: 战队id  userId：用户id
 */
export const removeMemberToTeamApi = (params: RequestParams) => Http.post("/api/v2/doctor/member/removeMemberToTeam", params);

/**
 * @description 创建患者
 * @param params
 */
export const setPatient = (params: RequestParams) => Http.post("/api/v2/doctor/member/setpatient", params);

/**
 * @description 获取项目
 * @param params
 */
export const getProject = (params: RequestParams) => Http.post("/api/v2/doctor/member/getproject", params);
/**
 * @description 获取项目阶段
 * @param params
 */
export const getProjectitem = (params: RequestParams) => Http.post("/api/v2/doctor/member/getprojectitem", params);

/**
 * @description 获取患者项目列表
 * @param params
 */
export const getPatientproject = (params: RequestParams) => Http.post("/api/v2/doctor/member/getpatientproject", params);
export const getPatientprojectApi = (params: RequestParams) => Http.post("/api/v2/doctor/member/getbindprojectform", params);


/**
 * @description 复制表单
 * @param params
 */
export const fuzhiForm = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/fuzhiform", params);
/**
 * @description 项目列表
 * @param params
 */
export const getProjectListApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getprojectlist", params);
export const getyonghumingxilist = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getyonghumingxilist", params);
export const getruzuxingweilist = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getruzuxingweilist", params);
export const getrenwumingxilist = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getrenwumingxilist", params);
export const getliaotianrole = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getliaotianrole", params);
/**
 * @description 添加项目
 * @param params
 */
export const addXiangmuApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/saveproject", params);
/**
 * @description 添加项目
 * @param params
 */
export const updateXiangmuApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/saveproject", params);
/**
 * @description 删除项目
 * @param params
 */
export const deleteProject = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/deleteproject", params);
/**
 * @description 阶段列表
 * @param params
 */
export const getjieduan = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getjieduanlist", params);
/**
 * @description 添加项目
 * @param params
 */
export const addJieduanApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/savejieduan", params);
/**
 * @description 添加项目
 * @param params
 */
export const updateJieduanApi = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/savejieduan", params);
/**
 * @description 删除项目
 * @param params
 */
export const deleteJieduan = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/deletejieduan", params);
export const getformtypes = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/getformtypes", params);
export const fuzhijieduan = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/fuzhijieduan", params);
export const setPatientprojectitem = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/setPatientprojectitem", params);
export const symptom_select_page = (params: RequestParams) => Http.post("/api/v2/doctor/member/symptom_select_page", params);
export const symptom_save = (params: RequestParams) => Http.post("/api/v2/doctor/member/symptom_save", params);
export const symptomApi = (params: RequestParams) => Http.post("/api/v2/doctor/member/symptom", params);
export const copyproject = (params: RequestParams) => Http.post("/api/v2/doctor/Customform/copyproject", params);
export const getjsonlist = (params: RequestParams) => Http.post("/api/v2/lgcode/getjsonlist", params);
export const agreejson = (params: RequestParams) => Http.post("/api/v2/lgcode/agreejson", params);
export const disagreejson = (params: RequestParams) => Http.post("/api/v2/lgcode/disagreejson", params);
export const deleteformApi = (params: RequestParams) => Http.post("/api/v2/lgcode/deleteform", params);
export const getformroleApi = (params: RequestParams) => Http.post("/api/v2/lgcode/getformrole", params);

/** 上传文件 */
export const upload = (data: any) => {
    return Http.post("/api/common/upload", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }